var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { DateTime } from 'luxon';
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import { TextInput } from 'src/ui/components/Input/TextInput/TextInput';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { MAX_CHARACTERS_LIMIT } from './constants';
import { COLORS } from 'src/shared/styles/colors';
import styles from './Comments.module.scss';
import { E_TOOLTIP_POSITION, Tooltip } from 'src/ui/components/ToolTip/Tooltip';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var Comments = function (props) {
    var _a;
    var i18n = props.i18n, comments = props.comments, onSend = props.onSend;
    var _b = useState(comments.length > 0), isOpen = _b[0], setIsOpen = _b[1];
    var _c = useState(''), message = _c[0], setMessage = _c[1];
    var commentsContainerRef = useRef(null);
    var inputRef = useRef(null);
    useEffect(function () {
        if (commentsContainerRef.current) {
            commentsContainerRef.current.scrollTop = commentsContainerRef.current.scrollHeight;
        }
    }, [comments]);
    useEffect(function () {
        if (isOpen && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isOpen, inputRef]);
    var chatWrapperClassName = classNames(styles.commentsChatWrapper, (_a = {},
        _a[styles.commentsChatWrapperOpen] = isOpen,
        _a));
    var handleCommentOpen = function (e) {
        e.stopPropagation();
        setIsOpen(true);
    };
    var handleMessageChange = function (newValue) {
        setMessage(newValue);
    };
    var handleControlEnter = function (e) {
        if (e.key === 'Enter') {
            if (e.shiftKey) {
                setMessage("".concat(message, " \r\n"));
            }
            else {
                e.preventDefault(); // don't trigger handleMessageChange and send message
                if (message.length > 1 && !isMessageTooLong) {
                    handleSendMessage();
                }
            }
        }
    };
    var handleSendMessage = function () {
        if (isMessageTooLong) {
            return;
        }
        onSend(message.trim()); // send message .trim() to remove the last \r
        setMessage('');
    };
    var titleLabel = getPropsByKeyPath(i18n.modules, 'internalComments.headerTitle');
    var placeholderLabel = getPropsByKeyPath(i18n.modules, 'internalComments.placeholder');
    var numberOfCarriageReturn = Math.min(message.split('\n').length, 10);
    var isMessageTooLong = message.length > MAX_CHARACTERS_LIMIT;
    var messageLengthInfo = "".concat(message.length, " / ").concat(MAX_CHARACTERS_LIMIT);
    return (_jsxs("div", __assign({ className: styles.commentsWrapper }, { children: [_jsxs("div", __assign({ className: styles.commentsIcons, onClick: handleCommentOpen }, { children: [comments.length > 0 && _jsx("div", __assign({ className: styles.commentsBadgeNumberOfComment }, { children: comments.length })), _jsx(Icons, { icon: E_ICONS.CHAT, color: COLORS.WHITE })] })), _jsxs("div", __assign({ className: chatWrapperClassName }, { children: [_jsxs("div", __assign({ className: styles.chatWrapperHead, onClick: function () { return setIsOpen(false); } }, { children: [_jsx("p", __assign({ className: styles.chatWrapperHeadText }, { children: titleLabel })), _jsx(Icons, { icon: E_ICONS.CLOSE, color: COLORS.WHITE })] })), _jsx("div", __assign({ className: styles.chatWrapperContent, ref: commentsContainerRef }, { children: comments.map(function (comment) {
                            var firstLetterAuthor = comment.author.substring(0, 1);
                            var commentDate = comment.date.toLocaleString(DateTime.DATETIME_MED);
                            return (_jsxs("div", __assign({ className: styles.chatWrapperContentItemTextWrapper }, { children: [_jsxs("div", __assign({ className: styles.chatWrapperContentItemMessageWrapper }, { children: [_jsx("p", __assign({ className: styles.chatWrapperContentItemMessage }, { children: comment === null || comment === void 0 ? void 0 : comment.text })), _jsxs("p", __assign({ className: styles.chatWrapperContentItemDate }, { children: [_jsx("b", { children: comment.author }), " - ", _jsx("span", { children: commentDate })] }))] })), _jsxs("div", __assign({ className: styles.chatWrapperContentItemAvatar }, { children: [_jsx(Tooltip, __assign({ position: E_TOOLTIP_POSITION.LEFT, className: styles.chatWrapperAvatarTooltip }, { children: comment.author })), firstLetterAuthor] }))] }), comment === null || comment === void 0 ? void 0 : comment.date));
                        }) })), _jsx("div", __assign({ className: styles.chatWrapperInputWrapper, onKeyDown: handleControlEnter }, { children: _jsx(TextInput, { ref: inputRef, placeholder: placeholderLabel, value: message, multiple: true, maxRows: numberOfCarriageReturn, onChange: handleMessageChange, rightIcon: E_ICONS.SEND, iconColor: COLORS.PRIMARY['500'], onIconClick: handleSendMessage, className: styles.chatWrapperInput, isError: isMessageTooLong, withInfo: true, infoMessage: messageLengthInfo }) }))] }))] })));
};
